/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
/* eslint-disable no-nested-ternary */
// Libraries

// Helper
import {
    getFormInitialValues,
    getDependentSectionName,
    getFormattedPGConfigOldData,
} from '../../utils/helperMethods';

// Actions
import {
    updatePgStatusRequest,
    savePgDetailsRequest,
    updatePgsRequest,
    resetSavedPgs,
} from '../../containers/MerchantOnboard/redux/pgConfig/pgConfig.actions';
import {
    saveAndContinueRequest,
    resetSaveDataSuccessKey,
} from '../../containers/MerchantOnboard/redux/merchantOnBoard.actions';
import {
    updatePgConfigDataRequest,
    resetUpdateDataSuccessKey,
    fetchPgConfigDetailsRequest,
    addMerchantStepUpdateMakerRequest,
    getMerchantSectionInfoRequest,
} from '../../containers/MerchantOnboard/redux/editMerchant/editMerchant.actions';

// Constant
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';

// Component
import { AlertModal } from '../../components/';
import { pgDetails } from './DummyData';
import DetailsForm from './DetailsForm';
import ConfigDetails from './ConfigDetails';
import { last, first } from 'lodash';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

// Styles
import './pgConfigTab.scss';
import { MAKER_CHECKER_EVENT_TYPES } from 'utils/constants/commonValues';

const PGConfigTab = ({
    actions,
    name,
    pgData,
    merchantData,
    history,
    nextPath,
    previousPath,
    sectionType,
    auth,
    initialValues,
    isEditMode,
    isViewMode,
    editData,
    onBoardSteps,
    isInEditMode,
}) => {
    const { pgList, savedPgs } = pgData;
    const {
        saveData,
        uniqueIdentifier: { uniqueId },
        timeline: { fields },
        formInProcess,
    } = merchantData;

    const { updateData } = editData;
    const { location } = history;
    const [isConfig, setIsConfig] = useState(false);
    const [isChange, setIsChange] = useState(false);
    const [configDetails, setConfigDetails] = useState([]);
    const [configMode, setConfigMode] = useState(null);
    const [selectedPaymentMode, setSelectedPaymentMode] = useState([]);
    const [selectedPaymentSubMode, setSelectedPaymentSubMode] = useState({});

    const filterAndSetPaymentMode = paymentModeData => {
        const { paymentModeDetails } = paymentModeData;

        const paymentTypeMap = {};
        let paymentTypeList = [];

        for (const obj of paymentModeDetails) {
            const paymentType = obj.paymentType;
            const paymentModeInfo = obj.paymentModeInfo;
            const paymentModeInfoUI = obj.paymentModeInfoUI;

            if (!paymentTypeMap[paymentType]) {
                paymentTypeMap[paymentType] = [];
            }

            if (!paymentTypeList.includes(paymentType)) {
                paymentTypeList.push(paymentType);
            }

            paymentTypeMap[paymentType].push({
                name: paymentModeInfoUI ? paymentModeInfoUI : paymentModeInfo,
                value: paymentModeInfo,
            });
        }

        paymentTypeList = paymentTypeList.map(paymentType => {
            return {
                name: paymentType,
                value: paymentType,
            };
        });

        setSelectedPaymentMode(paymentTypeList);
        setSelectedPaymentSubMode(paymentTypeMap);
    };

    const currentStep = first(
        onBoardSteps.filter(item => item.sectionType === sectionType)
    );

    const [isShowModal, setIsShowModal] = useState(false);

    const onSuccessModal = () => {
        setIsShowModal(false);
        handleSubmit();
    };

    const onCloseModal = () => {
        setIsShowModal(false);
    };

    const resetErrors = () => {
        if (isEditMode) {
            actions.resetUpdateDataSuccessKey();
        } else {
            actions.resetSaveDataSuccessKey();
        }
    };

    useEffect(() => {
        resetErrors();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isEditMode || isViewMode) {
            const merchantId = last(location.pathname.split('/'));
            actions.fetchPgConfigDetailsRequest(merchantId, fields);
            actions.getMerchantSectionInfoRequest(
                merchantId,
                fields,
                'paymentModeSection'
            );
        }
    }, [actions, fields, isEditMode, isViewMode, location.pathname]);

    useEffect(() => {
        if (isEditMode || isViewMode) {
            const selectedPaymentMode = editData.sections.find(
                section => section.type === 'paymentModeSection'
            )?.data;

            if (selectedPaymentMode) {
                filterAndSetPaymentMode(selectedPaymentMode);
            }
        } else {
            const currentForm = formInProcess.forms.find(
                item => item.uniqueIdentifier === uniqueId
            );

            const selectedPaymentMode = currentForm.sections.find(
                section => section.type === 'paymentModeSection'
            ).data;

            filterAndSetPaymentMode(selectedPaymentMode);
        }
    }, [formInProcess, isEditMode, isViewMode, uniqueId, editData]);

    const onNext = () => {
        resetErrors();
        history.push(nextPath);
    };
    const onBack = () => {
        resetErrors();
        history.push(previousPath);
    };

    const setInitialPgConfig = () => {
        const pgList = Object.keys(
            isEditMode || isViewMode
                ? initialValues
                : getFormattedPGConfigOldData(initialValues)
        );
        const listOfPgs = pgList.map(item => {
            if (item.includes('ConfLive')) {
                return item.replace('ConfLive', '');
            } else if (item.includes('ConfTest')) {
                return item.replace('ConfTest', '');
            }
            return '';
        });
        const uniqueListOfPgs = [...new Set(listOfPgs)];
        uniqueListOfPgs.forEach(pgs => {
            setTimeout(() => {
                actions.updatePgsRequest(pgs, initialValues);
            }, 200);
        });
    };

    useEffect(() => {
        if (initialValues && Object.keys(initialValues).length) {
            actions.savePgDetailsRequest(
                isEditMode || isViewMode
                    ? initialValues
                    : getFormattedPGConfigOldData(initialValues)
            );
            setInitialPgConfig();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actions, initialValues]);

    useEffect(() => {
        if (saveData.isSuccess && saveData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.SAVE_DATA(name));
            onNext();
        }
        return () => {
            if (saveData.isSuccess && saveData.sectionType === sectionType) {
                actions.resetSaveDataSuccessKey();
                actions.resetSavedPgs({});
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveData.isSuccess, saveData.sectionType]);

    useEffect(() => {
        if (updateData.isUpdated && updateData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.UPDATE_MAKER_REQUEST_SUCCESS(name));
            onNext();
        }
        return () => {
            if (
                updateData.isUpdated &&
                updateData.sectionType === sectionType
            ) {
                actions.resetUpdateDataSuccessKey();
                actions.resetSavedPgs({});
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateData.isUpdated, updateData.sectionType]);

    const onConfig = (configType, configDetails) => {
        setIsConfig(true);
        setIsChange(true);
        setConfigMode(configType);
        setConfigDetails(configDetails);
    };

    const handleBackClick = () => {
        setIsConfig(false);
    };

    const generateRequestData = (savedPgs, pgDetails) => {
        const requestData = [];
        const savedPgsConfigName = Object.keys(savedPgs);

        savedPgsConfigName.forEach((itemName, index) => {
            const configIndex = pgDetails.findIndex(pg =>
                itemName.includes(pg.uniqueId)
            );

            if (configIndex >= 0) {
                const pgConf = pgDetails[configIndex];
                requestData.push({
                    pgName: pgConf.uniqueId,
                    environment: 'LIVE',
                    integration: 'DEFAULT',
                    credentials: savedPgs[itemName].credentials.map(
                        (cred, index) => {
                            return {
                                ...cred,
                                isUpdated: savedPgs[itemName].isUpdated,
                                status:
                                    cred.status &&
                                    cred.status.length &&
                                    cred.status[0] === 'ENABLED'
                                        ? true
                                        : false,
                            };
                        }
                    ),
                });
            }
        });

        return requestData;
    };

    const handleSubmit = () => {
        if (
            currentStep &&
            currentStep.dependentSections &&
            currentStep.dependentSections.length &&
            currentStep.status === 'Complete' &&
            isChange &&
            !isShowModal
        ) {
            setIsShowModal(true);
        } else {
            const requestData = generateRequestData(savedPgs, pgDetails);

            const request = {
                uniqueIdentifier: uniqueId,
                sectionType,
                data: { paymentGatewayDtoList: requestData },
            };

            if (isEditMode) {
                const merchantId = last(location.pathname.split('/'));
                const updateRequest = {
                    entityCode: merchantId,
                    paymentGatewayDtoList: requestData,
                };

                const makerDetails = {
                    makerId: auth.userDetails.email || '',
                    idempotencyId: merchantId,
                    eventType: MAKER_CHECKER_EVENT_TYPES.PG_CONFIG,
                };
                actions.addMerchantStepUpdateMakerRequest(
                    updateRequest,
                    sectionType,
                    makerDetails
                );
            } else if (isViewMode) {
                onNext();
            } else {
                actions.saveAndContinueRequest(request, sectionType);
            }
        }
    };

    const handleModeSwitch = (values, uniqueId) => {
        setIsChange(true);
        actions.updatePgStatusRequest({ values, uniqueId });
    };

    const errorDetails = isEditMode ? updateData : saveData;
    const isOrAre = currentStep.dependentSections.length > 1 ? 'are' : 'is';

    return (
        <>
            <AlertModal
                modalIsOpen={isShowModal}
                closeModal={onCloseModal}
                primaryButtonText="OK"
                secondaryButtonText="CANCEL"
                showActions={true}
                currentSection={currentStep}
                onSuccessModal={onSuccessModal}
                message={`${getDependentSectionName(
                    onBoardSteps,
                    currentStep.dependentSections
                )}
                ${isOrAre} dependent on ${currentStep.name}
                section. Please update dependent sections.`}
            />
            {isConfig ? (
                <ConfigDetails
                    onNext={onNext}
                    onBack={onBack}
                    configMode={configMode}
                    data={configDetails}
                    onBackClick={handleBackClick}
                    onModeSwitch={handleModeSwitch}
                    savedPgs={savedPgs}
                    isEditMode={isEditMode}
                    initialValues={getFormInitialValues(
                        savedPgs,
                        configDetails
                    )}
                    isViewMode={isViewMode}
                    paymentModeOptions={selectedPaymentMode}
                    paymentSubModeOptions={selectedPaymentSubMode}
                />
            ) : pgList && pgList.length > 0 ? (
                <DetailsForm
                    onNext={onNext}
                    onBack={onBack}
                    onConfig={onConfig}
                    data={pgList}
                    savedPgs={savedPgs}
                    previousPath={previousPath}
                    errorMessage={
                        errorDetails.error && errorDetails.error.errorMessage
                    }
                    onSubmit={handleSubmit}
                    onModeSwitch={handleModeSwitch}
                    isViewMode={isViewMode}
                />
            ) : null}
        </>
    );
};

PGConfigTab.propTypes = {
    actions: PropTypes.object,
    merchantData: PropTypes.object,
    pgData: PropTypes.object,
    history: PropTypes.object,
    nextPath: PropTypes.string,
    previousPath: PropTypes.string,
    name: PropTypes.string,
    sectionType: PropTypes.string,
    auth: PropTypes.object,
    initialValues: PropTypes.object,
    isEditMode: PropTypes.bool,
    isViewMode: PropTypes.bool,
    editData: PropTypes.object,
    onBoardSteps: PropTypes.array,
    isInEditMode: PropTypes.bool,
};

const mapStateToProps = ({ auth, pgData, merchantData, editData }) => ({
    auth,
    pgData,
    merchantData,
    editData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            saveAndContinueRequest,
            updatePgStatusRequest,
            savePgDetailsRequest,
            updatePgsRequest,
            resetSaveDataSuccessKey,
            updatePgConfigDataRequest,
            resetUpdateDataSuccessKey,
            fetchPgConfigDetailsRequest,
            getMerchantSectionInfoRequest,
            resetSavedPgs,
            addMerchantStepUpdateMakerRequest,
        },
        dispatch
    ),
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(PGConfigTab)
);
